var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24596 8.11248C6.88138 8.11248 6.5931 8.39239 6.5931 8.7464C6.5931 9.09217 6.88138 9.38032 7.24596 9.38032H12.3332V13.3156C12.3332 15.3326 10.6459 16.9791 8.56016 16.9791H4.43104C2.35376 16.9791 0.666504 15.3408 0.666504 13.3238V4.17724C0.666504 2.15198 2.36224 0.513672 4.43952 0.513672H8.57712C10.6459 0.513672 12.3332 2.15198 12.3332 4.169V8.11248H7.24596ZM15.3582 5.89803L17.7916 8.29375C17.9166 8.41724 17.9832 8.57366 17.9832 8.74654C17.9832 8.9112 17.9166 9.07585 17.7916 9.19111L15.3582 11.5868C15.2332 11.7103 15.0666 11.7762 14.9082 11.7762C14.7416 11.7762 14.5749 11.7103 14.4499 11.5868C14.1999 11.3399 14.1999 10.9364 14.4499 10.6895L15.7832 9.38046H12.3333V8.11263H15.7832L14.4499 6.80362C14.1999 6.55664 14.1999 6.15324 14.4499 5.90626C14.6999 5.65104 15.1082 5.65104 15.3582 5.89803Z",
    fill: "#030229"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.061a6861508f5c1f714a72a5a0d12ea4.svg";
export { ForwardRef as ReactComponent };